import Vue from 'vue';
import { LOGOUT } from "../store/types";
export default Vue.extend({
    name: "TopBar",
    props: {
        showLogOut: { type: Boolean, default: false },
    },
    methods: {
        doLogout() {
            this.$store.dispatch(LOGOUT);
        },
    }
});
